import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import Select from "../../shared/InputElements/Select";
import {useIntl} from 'react-intl';

const SelectHouseholdSize = ({
  id = "household-size",
  ...rest
}) => {
  const intl = useIntl()
  const userPrefs = useContext(UserPrefsContext);
  const label = intl.formatMessage({ id: "incentives.householdSize", defaultMessage: "Household Size"})

  return (
    <Select
      id={id}
      value={userPrefs.get("householdSize").toString()}
      label={label}
      optionNames={["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]}
      optionValues={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
      handler={e => userPrefs.set({ householdSize: e.target.value })}
    />
  );
};

export default SelectHouseholdSize;

SelectHouseholdSize.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  tooltip: PropTypes.string
};
